import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { TransactionActionCommand } from "../transaction/transaction.model";
import { AppSettings } from "../../app.settings";
import { LookupType } from "../account/account.model";
import { BankAccountRole, TransactionPreviewResponse } from "common";
import { DrawCommand, PayCommand } from "./loan-transaction.model";

@Injectable({
    providedIn: 'root'
})
export class LoanService {

    constructor(private http: HttpClient, private settings: AppSettings) { }

    draw(id: number, command: DrawCommand): Observable<any> {
        const url = `${this.settings.transaction.url}/api/transactions/draw/${id}`;
        return this.http.post(url, command);
    }

    drawPreview(id: number, amount: number, initiatorType: string, initiatorId: string, promoCode?: string): Observable<TransactionPreviewResponse> {
        return this.http.get<TransactionPreviewResponse>(`${this.settings.transaction.url}/api/transactions/draw/${id}`, { params: { amount, initiatorType, initiatorId, promoCode } });
    }

    pay(id: number, command: PayCommand): Observable<any> {
        const url = `${this.settings.transaction.url}/api/transactions/pay/${id}`;
        return this.http.post(url, command);
    }

    payPreview(id: number, amount: number, initiatorType: string, initiatorId: string, promoCode?: string): Observable<TransactionPreviewResponse> {
        return this.http.get<TransactionPreviewResponse>(`${this.settings.transaction.url}/api/transactions/pay/${id}`, { params: { amount, initiatorType, initiatorId, promoCode } });
    }

    transaction(loanId: number, command: TransactionActionCommand): Observable<any> {
        const url = `${this.settings.transaction.url}/api/transactions/${loanId}`;
        return this.http.post(url, command);
    }

    lookup(requestedLookup: LookupType, value?: string): Observable<any> {
        const params = new HttpParams()
            .set('requestedLookup', requestedLookup.toString())
            .set('value', value || '');
        return this.http.get(`${this.settings.loans.url}/api/account/lookup`, { params: params })
            .pipe(map(res => res));
    }

    updateTransferBankAccount(id: number, bankAccountId: number, bankAccountRole: BankAccountRole) {
        const url = `${this.settings.loans.url}/api/account/${id}/transfer-bank?role=${bankAccountRole}`;
        return this.http.put(url, { bankAccountId });
    }
}
